<template>
    <div class="components-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-select v-model="queryForm.semesterCode" placeholder="学年学期" style="width: 250px;" clearable>
                <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="unlockAll" type="danger"><i class="el-icon-unlock"></i>&nbsp;全部解锁</el-button>
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="锁定类型" prop="lockType" width="150" align="center" :formatter="lockTypeFormatter"></el-table-column>
            <el-table-column label="学年学期名称" prop="semesterName" align="center"></el-table-column>
            <el-table-column label="班级名称" prop="className" align="center"></el-table-column>
            <el-table-column label="操作人姓名" prop="teaName" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button type="danger" size="small" @click="unlock(scope.row)">
                        <i class="el-icon-unlock"></i>&nbsp;解锁
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                mainTableHeight: 500,
                //查询列表数据
                queryForm: {
                    semesterCode: null,
                },
                //下拉框选项数据
                comboOption: {
                   semester: null,
                },
                //表数据
                tableData: [],
                tableLoading: true,
                loadingMask: null,
            }
        },
        mounted() {
            this.initCombo();
            this.queryList();
        },
        methods: {
            initCombo() {
                this.$api.timetableManage.arrange.initCombo({}).then((res) => {
                    this.comboOption.semester = res.data.data.semesterComboData;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.$api.timetableManage.unlock.queLockList({
                    data: this.queryForm,
                }).then((res) => {
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            handleFilter() {
                this.queryList();
            },
            handleReset() {
                this.queryForm.semesterCode = null;
                this.queryList();
            },
            handleCurrentChange(){
                
            },
            lockTypeFormatter(row){
                return row.lockType === 'autoLocked' ? '自动排课锁定' : '手动排课锁定';
            },
            unlock(rowData){
                confirmMsg('是否确定要解锁当前选中的排课状态').then(() => {
                    this.showLoadingMask('正在解锁排课，请稍候...');
                    const params = {
                        lockType: rowData.lockType,
                        semesterCode: rowData.semesterCode,
                        classCode: rowData.classCode
                    };

                    this.$api.timetableManage.unlock.unlock({
                        data: params,
                    }).then((res) => {
                        showNotify('成功', '解锁成功', 'success', 1500);
                        this.queryList();
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    }).finally(() => {
                        this.closeLoadingMask();
                    });
                });
            },
            unlockAll(){
                confirmMsg('是否确定要解锁所有排课锁定状态').then(() => {
                    this.showLoadingMask('正在解锁排课，请稍候...');
                    this.$api.timetableManage.unlock.unlock({
                        data: {
                            lockType: 'all',
                            semesterCode: '',
                            classCode: ''
                        },
                    }).then((res) => {
                        showNotify('成功', '解锁成功', 'success', 1500);
                        this.queryList();
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    }).finally(() => {
                        this.closeLoadingMask();
                    });
                });
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
        }
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// unlock.vue?01624757